import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const Section = styled.div`
  border-bottom: ${({ withoutBorder }) => (!withoutBorder ? `1px solid ${select('neutralDarkGray')}` : 'none')};
  padding: 16px 0px;
`;

const ToggleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  .titleContainer {
    font-family: Hind;
    font-weight: ${({ fontWeight }) => fontWeight};
    font-size: ${({ fontSize }) => fontSize};
    line-height: ${({ lineHeight }) => lineHeight};
    display: flex;
    align-items: center;
    gap: 8px;
  }
  > button {
    margin-bottom: 5px;
  }
`;

const ContentWrapper = styled.div`
  max-height: ${({ active }) => (active ? 'fit-content' : 0)};
  opacity: ${({ active }) => (active ? 1 : 0)};
  overflow: hidden;
  transition: opacity 0.3s ease-in-out;
`;

export { Section, ToggleContainer, ContentWrapper };
